// @flow

import React, { type Node } from 'react';
import { MerchantInfo } from '../../../organisms/merchant-info';
import { CardInfo } from './card-info';
import styled from 'styled-components';
import { BillingDescriptor } from './billing-descriptor';
import { EmailInfo } from './email-info';

export function CreditCardPage(): Node {
  return (
    <Content>
      <Body>
        <EmailInfo />
        <CardInfo />
        <Hr />
        <BillingDescriptor />
        <Hr />
        <MerchantInfo />
      </Body>
    </Content>
  );
}

const Body = styled.div`
  line-height: 1.5;
`;

const Hr = styled.hr`
  display: block; height: 1px;
  border: 0;
  border-top: 1px solid rgb(244, 246, 248);
  margin: 1em 0;
  padding: 0;
`;

const Content = styled.section`
  height: 100vh;
  display: flex;
  flex-direction: column;

  text-align: center;
  font-family: ${props => props.theme.fontFamily.sansSerif};
  padding: 16px;

  > * {
    width: 100%;
    margin: 6px auto;
  }

  @media (min-width: 840px) {
    height: auto;
    padding: 0 16px 32px 16px;
  }
`;
